const WorkflowItemTypes = Object.freeze({
  HEAT_ON: "heatOn",
  SET_LED_BRIGHTNESS: "setLEDbrightness",
  WAIT: "wait",
  HEAT_OFF: "heatOff",
  FAN_ON: "fanOn",
  FAN_ON_GLOBAL: "fanOnGlobal",
});

export default WorkflowItemTypes;
